import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavBar from "../Comp/NavBar";
import Footer from "../Comp/Footer";

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const currentUser = useSelector((state) => state.currentUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser?.loggedIn || !currentUser?.user?.id) { navigate("/Login"); return; }
    fetchOrders();
    // eslint-disable-next-line
  }, [currentUser, navigate]);

  const fetchOrders = async () => {
    try {
      setLoading(true); setError("");
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/orders/user?user_id=${currentUser.user.id}`);
      let data = response.data;
      if (typeof data === "string") {
        const jsonStart = data.indexOf("{");
        data = JSON.parse(jsonStart > 0 ? data.substring(jsonStart) : data);
      }
      if (data.success && data.orders) setOrders(data.orders);
      else setError(data.error || "Failed to fetch orders");
    } catch (err) {
      setError(err.message || "Failed to load orders");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <NavBar />
      <div className="oot-orders">
        <h1>My Orders</h1>
        {error && <div className="oot-banner-err">{error}</div>}

        {loading ? (
          <div className="oot-cart-empty">Loading your orders…</div>
        ) : orders.length === 0 ? (
          <div className="oot-cart-list"><div className="oot-cart-empty">
            You have no orders yet.<br /><br />
            <button className="oot-btn oot-btn-primary" onClick={() => navigate("/")}>Continue shopping</button>
          </div></div>
        ) : (
          <table className="oot-table">
            <thead>
              <tr><th>Order ID</th><th>Date</th><th>Status</th><th style={{ textAlign: "right" }}>Total</th><th style={{ textAlign: "center" }}>Action</th></tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id}>
                  <td>#{order.id}</td>
                  <td>{new Date(order.date).toLocaleDateString()}</td>
                  <td><span className={`oot-status ${order.status === "pending" ? "pending" : "done"}`}>{order.status}</span></td>
                  <td style={{ textAlign: "right", fontWeight: 700 }}>${(order.total || 0).toFixed(2)}</td>
                  <td style={{ textAlign: "center" }}>
                    <button className="oot-btn oot-btn-ghost" style={{ padding: "7px 16px" }}
                      onClick={() => navigate(`/OrderConfirmation/${order.id}`)}>View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default MyOrders;
